export default __webpack_public_path__ + "static/media/rainbowl-menu.5ac0a475.pdf";